import styled from 'styled-components';
import { pxToRem } from 'utils/convert';
import { PageSizeSelector } from './PageSizeSelector';

export const StyledPageSizeSelector = styled(PageSizeSelector)`
  float: right;
  font-weight: bold;
  min-width: ${pxToRem(30)};
  min-height: ${pxToRem(30)};
  transition: background 0.2s, border-color 0.2s, box-shadow 0.2s;
  user-select: none;
`;

export const PaginationContainer = styled.div`
  padding-top: ${pxToRem(10)};
`;

export const FilterContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  > .ui.input {
    width: ${pxToRem(300)};
    margin-bottom: ${pxToRem(5)};
  }
`;

export const TableContainer = styled.div<{ $isToolbarShown: boolean }>`
  height: 100%;
  display: flex;
  flex-direction: column;
  flex: 0 0 auto;
  &[data-appearance='normal'] {
    .coreTableRow:hover {
      background: #eaf4fa;
    }
    .coreTableHeaderCell {
      vertical-align: middle;
      background: #eff0f0;
      > button,
      > div:not(.ui.checkbox) {
        height: ${pxToRem(32)};
        box-sizing: border-box;
      }
      > div(.ui.checkbox) {
        vertical-align: middle;
      }
      [data-theme='dark'] & {
        background: #222;
        > button,
        > div:not(.ui.checkbox) {
          color: #eff0f0;
        }
      }
    }
    ${({ $isToolbarShown }) =>
      $isToolbarShown
        ? `
      border: ${pxToRem(1)} solid #eff0f0;
      .coreTableHeaderCell {
          border-bottom: ${pxToRem(1)} solid #d6d6d6;
          background: #fff;
          &:first-child {
            border-top: ${pxToRem(1)} solid #fff;
          }
          &,
          > * {
            font-weight: 600;
            color: #333;
            &[type='button']:hover {
              color: #2e8ece;
            }
          }
        }
        `
        : ''}
  }
  &[data-appearance='iterable'] {
    .coreTableHeaderCell {
      background: #444;
      transition: background 0.2s, border-color 0.2s, box-shadow 0.2s;
      > button,
      > div:not(.ui.checkbox) {
        color: #fff;
        padding: ${pxToRem(15)};
        font-weight: bold;
        text-shadow: 1px 1px 1px #000;
        height: ${pxToRem(52)};
        box-sizing: border-box;
        > i.sort {
          color: #616161;
          text-shadow: none;
          transition: color 0.2s;
        }
      }
      &[data-sortable='true']:hover {
        background: #555;
        > button {
          color: #fff !important;
        }
      }
      > div.checkbox {
        padding: ${pxToRem(15)};
      }
      &[data-active-sort='true'] {
        background: #616161;
        > button {
          background: #616161;
        }
      }
      &[data-active-sort='true'],
      &:hover {
        > button {
          > i.sort {
            color: #fcfcfc !important;
          }
        }
      }
      &[data-docked='true'] {
        border-right: ${pxToRem(1)} solid #717171;
      }
    }
    .coreTableHeaderRow {
      border-top-left-radius: ${pxToRem(3)};
      border-top-right-radius: ${pxToRem(3)};
      position: sticky;
      top: 0;
      z-index: 4;
    }
    .coreTableRow {
      background-color: #f5f6f6;
      .coreTableCell {
        border-bottom: ${pxToRem(1)} solid #d6d6d6;
      }
    }
    ${({ $isToolbarShown }) =>
      $isToolbarShown
        ? `
        .coreTableRow {
            .coreTableCell {
              &:first-child {
                border-left: ${pxToRem(1)} solid #d6d6d6;
              }
              &:last-child {
                border-right: ${pxToRem(1)} solid #d6d6d6;
              }
            }
          }
        `
        : ''}
  }
`;
